<template>
    <div class="outer">
      <div class="btn-wrap">
        <div class="btn" v-for="(page, key) in pages" @click="goto(page.url)" :key="key">
          {{page.name}}
        </div>
      </div>
      <div class="footer" @click="linkTo('https://beian.miit.gov.cn')">粤ICP备2026120544号</div>
    </div>
</template>

<script>
export default {
  name: 'Main',
  data () {
    return {
      pages: [
        {name: 'ILoveU', url: 'iLoveU'},
        {name: 'GuessNo', url: 'guessNo'},
        {name: 'Answers', url: 'answers'},
        {name: 'Stack', url: 'stack'}
      ]
    }
  },
  methods: {
    goto (page) {
      ![undefined, null, '', this.$route.path].includes(page) && this.$router.push('/'+page)
    },
    linkTo(url){
      window.open(url)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "main.styl"
</style>
